import React from 'react';
import MessageChannel from './messageChannel';

export default class OrderDeskLeadTimes extends React.Component<any,any> {
	render () {
		return (
			<div>
				<section>
					<MessageChannel allowNewMessages={ true } channelKey="cabinet-supplier-lead-time" className="inner" messageLabel="Lead Time Info" />
				</section>
			</div>
		);
	}
}